<template>
  <PbsWelcome />
</template>
<script lang="ts" setup>
import PbsWelcome from '@/components/PbsWelcome.vue';
</script>

<style lang="scss" scoped></style>
